// extracted by mini-css-extract-plugin
export default {"container":"OQpSPeoG","inner":"a7wkW1dd","inner__left":"x3AS8Xu4","inner__right":"ti2wHPr7","logo":"syvsjqJ7"};